module.exports = __webpack_public_path__ + "static/media/peripheral.8a13998d.ogg";